export default class Pagination {
  /*
   * Mandatory options: el, tmpl
   */
  constructor(options) {
    Object.assign(this, options);
  }

  render() {
    this.el.html(this.tmpl.render());
  }
}
